import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import  styles from "./question.module.css";
import Head from "next/head";
import Image from 'next/image';
import qrscan from "../../assets/images/upsc/DuePayment/summercamp.jpg";
import Upsdelhibanner from "../../assets/images/upsc/Kids-Summer-camp-Web-Banner.jpg";
import MobUpscdelhibanner from "../../assets/images/upsc/Kids-Summer-camp-Mobile-Banner.jpg";
import Calendar from "../../assets/images/icon/calendar_ColourSet.png"; 
import Clock from "../../assets/images/icon/clock-01.png";
import NewiconA from "../../assets/images/header/pdf-download1.png";


export default function index() {
  
const pyqData  = [ 

  {
    year: 2025,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2025-PAPER-I.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2025-PAPER-II.pdf",
  },

   {
    year: 2024,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2024-PAPER-I.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2024-PAPER-II.pdf",
  },

  {
    year: 2023,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2023-PAPER-I.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2023-PAPER-II.pdf",
  },

  {
    year: 2022,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2022-PAPER-I.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2022-PAPER-II.pdf",
  },

  {
    year: 2021,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2021-PAPER-I.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Qus-Papers/UPSC-Prelims-2021-PAPER-II.pdf",
  },
  

]; 

const AnsKey  = [ 

  {
    year: 2024,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2024-Prelims-Paper1-AnswerKey.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2024-Prelims-Paper2-AnswerKey.pdf",
  },

   {
    year: 2023,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2023-Prelims-Paper1-AnswerKey.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2023-Prelims-Paper2-AnswerKey.pdf",
  },

  {
    year: 2022,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2022-Prelims-Paper1-AnswerKey.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2022-Prelims-Paper2-AnswerKey.pdf",
  },

  {
    year: 2021,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2021-Prelims-Paper1-AnswerKey.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2021-Prelims-Paper2-AnswerKey.pdf",
  },

  {
    year: 2020,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2020-Prelims-Paper1-AnswerKey.pdf",
    paper2: "https://shankariasacademy.com/pdf/Upsc-Ans-Key/2020-Prelims-Paper2-AnswerKey.pdf",
  },
  

];

const cutofData  = [ 
  {
    year: 2020,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Cutoff/CSE-2020-Cut-off-Marks.pdf",
   
  },
  {
    year: 2021,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Cutoff/CSE-2021-Cut-off-Marks.pdf",
   
  },

  {
    year: 2022,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Cutoff/CSE-2022-Cut-off-Marks.pdf",
   
  },

  {
    year: 2023,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Cutoff/CSE-2023-Cut-off-Marks.pdf",
   
  },

  {
    year: 2024,
    paper1: "https://shankariasacademy.com/pdf/Upsc-Cutoff/CSE-2024-Cut-off-Marks.pdf",
   
  },

];

  return (
    <>
    <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index,follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>UPSC Previous Year Prelims Question Paper | Shankar IAS Academy</title>
            <meta name="title" content="UPSC Previous Year Prelims Question Paper | Shankar IAS Academy" />
            <meta name="description" content="Access UPSC Previous Year Prelims Question Papers with answer keys for all sets. Prepare effectively for the UPSC Civil Services Exam with Shankar IAS Academy's trusted resources." />
            <meta name="keywords" content="UPSC previous year question paper, UPSC prelims question paper, UPSC answer keys, UPSC past papers, UPSC CSE prelims, UPSC question paper with answers, Shankar IAS Academy, Civil Services Exam" />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-previous-question-paper/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="UPSC Previous Year Prelims Question Paper | Shankar IAS Academy" />
            <meta property="og:description" content="Access UPSC Previous Year Prelims Question Papers with answer keys for all sets. Prepare effectively for the UPSC Civil Services Exam with Shankar IAS Academy's trusted resources." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-previous-question-paper/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
    </Head>
    <Navbar />

      <div className="container pt-3 ">
        <div className="rows pt-3 pb-3">
            <h1 className={`${styles.sectiontitle}`}> UPSC Previous Year  Prelims Question Papers</h1>
        </div>
      </div>

      {/*<div className="container">
            <div className="row d-none d-md-block">
                <div className="col mb-3">
                  <Image
                    src={Upsdelhibanner}
                    alt="orientation banner"
                    title="UPSC orientation Test Series 2024"
                    className="img-fluid w-100"
                  />
                </div>
              </div>

              <div className="row d-block d-md-none">
              <div className="col mb-3">
                  <Image
                    src={MobUpscdelhibanner}
                    alt="orientation banner"
                    title="UPSC orientation"
                    className="img-fluid w-100"
                  />
                </div>
              </div>
        </div> */}

    <div className="container-fluid pt-3 pb-5">
          <section
            className="py-5"
            style={{
              background:
                "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgba(182, 238, 255, 0.29))",
            }}
          >
            <div className="container">
              <div className="text-center mb-5">
                <h3 className="fw-bold">Previous Year Question Papers</h3>
                <p className="text-muted">Download UPSC Prelims Papers – Paper I & II</p>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered align-middle text-center">
                  <thead className="table-light">
                    <tr>
                      <th>Year</th>
                      <th>Paper I (General Studies)</th>
                      <th>Paper II (CSAT)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pyqData.map((item, index) => (
                      <tr key={index}>
                        <td className="fw-semibold">
                          
                          {item.year}
                        </td>
                        <td>
                          <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                            <div className="d-flex align-items-center me-2">
                              <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"28px",color:"#DB1B0D"}}></i>
                              <span className="fw-medium">GS Paper</span>
                            </div>
                            <a
                              href={item.paper1}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                            >
                              Download
                            </a>
                          </div>
                      </td>

                      <td>
                          <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                            <div className="d-flex align-items-center me-2">
                             <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"28px",color:"#DB1B0D"}}></i>
                              <span className="fw-medium">CSAT Paper</span>
                            </div>
                            <a
                              href={item.paper2}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                            >
                              Download
                            </a>
                          </div>
                      </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
    </div>

    <div className="container-fluid pt-3 pb-5">
          <section
            className="py-5"
            style={{
              background:
                "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgba(182, 238, 255, 0.29))",
            }}
          >
            <div className="container">
              <div className="text-center mb-5">
                <h3 className="fw-bold">Previous Year Answer Key</h3>
                <p className="text-muted">Download UPSC Prelims Papers – Paper I & II</p>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered align-middle text-center">
                  <thead className="table-light">
                    <tr>
                      <th>Year</th>
                      <th>Paper I (General Studies)</th>
                      <th>Paper II (CSAT)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {AnsKey.map((item, index) => (
                      <tr key={index}>
                        <td className="fw-semibold">
                          
                          {item.year}
                        </td>
                        <td>
                          <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                            <div className="d-flex align-items-center me-2">
                               <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"28px",color:"#DB1B0D"}}></i>
                              <span className="fw-medium">GS  AnsKey</span>
                            </div>
                            <a
                              href={item.paper1}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                            >
                              Download
                            </a>
                          </div>
                      </td>

                      <td>
                          <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                            <div className="d-flex align-items-center me-2">
                              <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"28px",color:"#DB1B0D"}}></i>
                              <span className="fw-medium">CSAT AnsKey</span>
                            </div>
                            <a
                              href={item.paper2}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                            >
                              Download
                            </a>
                          </div>
                      </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
    </div>

    <section
          className="py-5"
          style={{
            background:
              "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgba(182, 238, 255, 0.29))",
          }}
        >

      <div className="container">
            <div className="text-center mb-5">
              <h3 className="fw-bold">Previous Year Cut Off Marks</h3>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered align-middle text-center">
                <thead className="table-light">
                  <tr>
                    <th>Year</th>
                    <th> Cut Off Marks</th>
                  
                  </tr>
                </thead>
                <tbody>
                  {cutofData.map((item, index) => (
                    <tr key={index}>
                      <td className="fw-semibold">
                        <Image
                          src={Calendar}
                          alt="Calendar"
                          width={24}
                          height={24}
                          className="me-2"
                        />
                        {item.year}
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                          <div className="d-flex align-items-center me-2">
                            <i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"28px",color:"#DB1B0D"}}></i>
                            <span className="fw-medium">Cut Off Marks</span>
                          </div>
                          <a
                            href={item.paper1}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                          >
                            Download
                          </a>
                        </div>
                    </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
      </div>
    </section>


    <Footer />
    </>
  )
}
